import React from "react";

interface EmbeddedMapProps {
  location: string;
  mapLink?: string;
  className?: string;
  height?: number;
  width?: string;
}

const EmbeddedMap: React.FC<EmbeddedMapProps> = ({
  location,
  mapLink = "#",
  className = "",
  height = 400,
  width = "100%",
}) => {
  // Your Google Maps API Key - store this in .env file
  const API_KEY =
    process.env.VITE_APP_GOOGLE_MAPS_API_KEY || "YOUR_API_KEY_HERE";

  // Encode the location for the URL
  const encodedLocation = encodeURIComponent(location);

  // Build the embed URL
  const embedUrl = `https://www.google.com/maps/embed/v1/place?key=${API_KEY}&q=${encodedLocation}`;

  return (
    <div
      className={`rounded-xl overflow-hidden shadow-lg border border-gray-200 ${className}`}
    >
      <div className="bg-gray-50 p-4 border-b flex justify-between items-center">
        <div className="flex items-center">
          <svg
            className="w-5 h-5 text-primary-green mr-2"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
              clipRule="evenodd"
            />
          </svg>
          <span className="text-gray-700 font-medium">Facility Location</span>
        </div>
        <a
          href={mapLink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary-green hover:text-blue-700 text-sm font-medium flex items-center"
        >
          <span>Open in Google Maps</span>
          <svg
            className="w-4 h-4 ml-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </a>
      </div>

      <iframe
        width={width}
        height={height}
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src={embedUrl}
        title={`Location of ${location}`}
        className="w-full"
      />

      <div className="bg-gray-50 p-3 text-xs text-gray-500 text-center border-t">
        <span>Interactive map powered by Google Maps</span>
      </div>
    </div>
  );
};

export default EmbeddedMap;
